import { c as _c } from "react/compiler-runtime";
import './child-bio-details.scss';
import { ElementType } from 'react';
import { useTranslation } from 'react-i18next';
import { ChildDetails } from '@sola/schema/dotcom/children/child.ts';
export const ChildBioDetailsHeading = t0 => {
  const $ = _c(8);
  const {
    hangul,
    name,
    seoLevel: t1
  } = t0;
  const seoLevel = t1 === undefined ? 1 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["bio"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation(t2);
  const Comp = `h${seoLevel}` as ElementType;
  const t3 = hangul.preferred || name.preferred;
  let t4;
  if ($[1] !== name.preferred || $[2] !== t || $[3] !== t3) {
    t4 = t("bio:title", {
      childName: name.preferred,
      koreanName: t3,
      interpolation: {
        escapeValue: false
      }
    });
    $[1] = name.preferred;
    $[2] = t;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== Comp || $[6] !== t4) {
    t5 = <Comp className="ChildBioDetails__heading heading-potent heading-xl mb-comfy-sm">{t4}</Comp>;
    $[5] = Comp;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};